import { BASE, LG, MD, SizesType, SM, XL, XM, XS, XSM, XXS } from '@/types/utils/sizesType';

import { LINKEDIN, X } from '@/lib/socialProfile';

export const socialIcon = 'absolute -bottom-[2px] -right-[6px] z-10 bg-white';

type AvatarSizeProps = {
    width: number;
    height: number;
    wrapperStyle: string;
    style: string;
};

type IconSizesSpecType<TSpecValue> = Record<Exclude<SizesType, 'xm' | 'xsm' | 'xxs'>, TSpecValue>;

export const avatarSize: Record<SizesType, AvatarSizeProps> = {
    [XL]: {
        width: 74,
        height: 74,
        wrapperStyle: 'w-[74px] h-[74px]',
        style: 'w-20 h-20'
    },
    [XM]: {
        width: 56,
        height: 56,
        wrapperStyle: 'w-14 h-14',
        style: 'w-14 h-14'
    },
    [LG]: {
        width: 48,
        height: 48,
        wrapperStyle: 'w-12 h-12',
        style: 'w-13 h-13'
    },
    [BASE]: {
        width: 42,
        height: 42,
        wrapperStyle: 'w-[42px] h-[42px]',
        style: 'w-[46px] h-[46px]'
    },
    [MD]: {
        width: 32,
        height: 32,
        wrapperStyle: 'w-8 h-8',
        style: 'w-9 h-9'
    },
    [SM]: {
        width: 28,
        height: 28,
        wrapperStyle: 'w-7 h-7',
        style: 'w-8 h-8'
    },
    [XS]: {
        width: 20,
        height: 20,
        wrapperStyle: 'w-5 h-5',
        style: 'w-5 h-5'
    },
    [XSM]: {
        width: 14,
        height: 14,
        wrapperStyle: 'w-3.5 h-3.5',
        style: 'w-3.5 h-3.5'
    },
    [XXS]: {
        width: 12,
        height: 12,
        wrapperStyle: 'w-3 h-3',
        style: 'w-3 h-3'
    }
};

export const avatarCustomColorClasses = [
    'bg-icoPurple-100 dark:bg-icoPurple/20 text-icoPurple',
    'bg-icoYellow-100 dark:bg-icoYellow/20 text-icoYellow',
    'bg-icoGreen-100 dark:bg-icoGreen/20 text-icoGreen',
    'bg-icoRed-100 dark:bg-icoRed/20 text-icoRed',
    'bg-icoPink-100 dark:bg-icoPink/20 text-icoPink',
    'bg-icoAquaBlue-100 dark:bg-icoAquaBlue/20 text-icoAquaBlue',
    'bg-icoOrange-100 dark:bg-icoOrange/20 text-icoOrange'
] as const;

export const fallbackFont: Record<Exclude<SizesType, 'md'>, string> = {
    [XL]: 'text-4xl leading-4 h-4',
    [XM]: 'text-3xl',
    [LG]: 'text-xl leading-4 h-4',
    [BASE]: 'text-xl leading-4 h-4',
    [SM]: 'text-sm leading-4 h-3.5',
    [XS]: 'text-xs leading-4 h-4',
    [XSM]: 'text-8 leading-2 h-[11px]',
    [XXS]: 'text-7 leading-1 h-[11px] pr-[1px]'
};

export const iconSize: IconSizesSpecType<string> = {
    [XL]: 'text-4xl',
    [LG]: 'text-3xl',
    [BASE]: 'text-xl',
    [SM]: 'text-xl',
    [MD]: 'text-xl',
    [XS]: 'text-xl'
};

export const iconX: IconSizesSpecType<string> = {
    [XL]: 'text-4xl',
    [LG]: 'text-3xl',
    [BASE]: 'text-xl',
    [SM]: 'text-xl',
    [MD]: 'text-xl',
    [XS]: 'text-xl'
};

export const iconThreads: IconSizesSpecType<string> = {
    [XL]: 'text-4xl',
    [LG]: 'text-3xl',
    [BASE]: 'text-xl',
    [SM]: 'text-xl',
    [MD]: 'text-xl',
    [XS]: 'text-xl'
};

export const iconTiktok: IconSizesSpecType<string> = {
    [XL]: 'text-4xl',
    [LG]: 'text-3xl',
    [BASE]: 'text-xl',
    [SM]: 'text-xl',
    [MD]: 'text-xl',
    [XS]: 'text-xl'
};

export const iconInstagram: IconSizesSpecType<number> = {
    [XL]: 42,
    [LG]: 32,
    [BASE]: 20,
    [SM]: 20,
    [MD]: 20,
    [XS]: 20
};

export const iconYoutube: IconSizesSpecType<number> = {
    [XL]: 42,
    [LG]: 32,
    [BASE]: 29,
    [SM]: 29,
    [MD]: 29,
    [XS]: 29
};

export const iconPinterest: IconSizesSpecType<number> = {
    [XL]: 42,
    [LG]: 32,
    [BASE]: 20,
    [SM]: 20,
    [MD]: 20,
    [XS]: 20
};

export const iconGroup: IconSizesSpecType<string> = {
    [XL]: 'text-lg',
    [LG]: 'text-base',
    [BASE]: 'text-xs',
    [MD]: 'text-8',
    [SM]: 'text-8',
    [XS]: 'text-8'
};

export const backgroundSize: IconSizesSpecType<string> = {
    [XL]: 'w-12 h-12',
    [LG]: 'w-9 h-9',
    [BASE]: 'w-6 h-6',
    [MD]: 'w-[1.45rem] h-[1.45rem]',
    [SM]: 'w-6 h-6',
    [XS]: 'w-4 h-4'
};

export const inSquareIcons = [LINKEDIN, X];

export const avatarSpacing = 'mr-3';
